import { ssoApi } from "@sso/apis";
import { ApiPageResponse } from "@sso/types";

import { TraccUsage } from "../../types/traccUsage";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

export const traccUsagesApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.TRACC_Usages] }).injectEndpoints({
  endpoints: builder => ({
    traccUsages: builder.query<ApiPageResponse<TraccUsage>, string>({
      query: query => ({ url: `${Endpoints.TRACC_Usages}/GetAll?${query}` }),
      providesTags: [CacheKeys.TRACC_Usages],
    }),
  }),
});

export const { useTraccUsagesQuery } =  traccUsagesApi;
